export default __webpack_public_path__ + "static/content-00b97cfea922421be4d12a92ae2d2310.jpg";